import React from 'react';
import { GetHeader } from '../types/get-header';

export function getHeader({
  business,
  verifySellerName,
  renderAmazonConnect,
}: GetHeader) {
  if (!verifySellerName && !renderAmazonConnect) {
    return "What's your Amazon Seller ID?";
  }
  if (verifySellerName) {
    return business?.name ? (
      <>
        <span>Awesome,</span>
        <br />
        <span>
          We found a store named <u>{business?.name}</u>.
        </span>
      </>
    ) : (
      'We could not find a Amazon store with the provided Seller ID.'
    );
  }
}
